export default "__VITE_ASSET__DQaYdvdK__"